import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { ReactComponent as LoaderSpinner } from '../../assets/icons/loading-spinner.svg';
import styles from './LoaderStyles.module.scss';
import cn from 'classnames';
export const Loader = ({ className, isTransparent = false, preventScroll = false }) => {
    useEffect(() => {
        if (preventScroll) {
            document.body.classList.add('prevent-scroll');
        }
        return () => {
            document.body.classList.remove('prevent-scroll');
            return;
        };
    }, []);
    return (_jsx("div", Object.assign({ className: cn(!isTransparent && styles.loaderWrapper, className) }, { children: _jsx(LoaderSpinner, {}) })));
};
export default Loader;
